import BoldDiagonalRed from "@/components/feature/BoldDiagonalRed";
import DiagonalLines from "@/components/feature/DiagonalLines";

export default function FlowPreview() {
  return (
    <section
      className="relative"
      style={{ background: "#ffffff", borderTop: "1px solid #e8e8e8" }}
    >
      {/* Bold diagonal red lines — single bold line */}
      <BoldDiagonalRed pattern="single" zIndex={0} opacity={0.12} />

      {/* Diagonal decorative lines */}
      <DiagonalLines variant="gold" intensity="light" />
    </section>
  );
}